import { render, staticRenderFns } from "./ColumnFilterSwitches.vue?vue&type=template&id=56a7921e&scoped=true&"
import script from "./ColumnFilterSwitches.vue?vue&type=script&lang=ts&"
export * from "./ColumnFilterSwitches.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnFilterSwitches.vue?vue&type=style&index=0&id=56a7921e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a7921e",
  null
  
)

export default component.exports